// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import Permissions from '../core/permissions';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import Select from '../core/select';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'networks';

class Networks extends Component {
    getColumnConfig() {
        return [
            {
                dataKey: 'name',
                link: '/networks',
                linkKey: 'networkId',
                title: 'Name',
                type: 'link',
                width: '15%',
            },
            {
                dataKey: 'networkId',
                title: 'Network ID',
                width: '10%',
            },
            {
                dataKey: 'alternateName',
                title: 'Alternate Name',
                width: '10%',
            },
            {
                dataKey: 'description',
                title: 'Description',
                width: '45%',
            },
            {
                dataKey: 'allowed',
                title: 'Allowed',
                type: 'boolean',
                width: '10%',
            },
            {
                dataKey: 'fastPath',
                title: 'Fast Path',
                type: 'boolean',
                width: '10%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getTablewithsortProps() {
        return {
            ...this.props,
            ...{
                activeRowKeys: ['networkId'],
                activeRowValueKey: 'routerParams.networkId',
                columnConfig: this.getColumnConfig(),
                servicesDataKey,
            },
        };
    }

    renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Name" name="name" title="Use wildcard (*) for partial name match" />
            <Select label="Has Network Logo" name="image">
                <option value="">All</option>
                <option value="notNull">Has Image</option>
                <option value="isNull">No Image</option>
            </Select>
            <Select label="Has DAI" name="adDecisioningSystem" title="Ad Decisioning System">
                <option value="">All</option>
                <option value="notNull">Has DAI</option>
                <option value="isNull">No DAI</option>
            </Select>
            <Select label="Has Fast Path" name="fastPath" title="Has Fast Path">
                <option value="">All</option>
                <option value="true">Has Fast Path</option>
                <option value="false">No Fast Path</option>
            </Select>
            <Select label="Has Cross Service Mapping" name="crossServiceMappingEnabled">
                <option value="">All</option>
                <option value="true">Has Cross Service Mapping</option>
                <option value="false">No Cross Service Mapping</option>
            </Select>
            <Select label="enabled for ad insertions" name="adInsertionEnabled">
                <option value="">All</option>
                <option value="true">AD Insertion Enabled</option>
                <option value="false">AD Insertion Disabled</option>
            </Select>
            <FormButtons />
        </ServicesSearchForm>
    );

    render() {
        const {searchData} = this.props;

        return (
            <Permissions
                accessRequirement="read"
                elementService="network"
                notAuthorizedMessage={true}
                requiresServiceAccess={true}
            >
                <div className="networks">
                    <ServicesExportPanelAction searchData={searchData} />
                    <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                    <SearchPagination {...this.getPaginationProps()} />
                    <SearchTableWithSort {...this.getTablewithsortProps()} />
                </div>
            </Permissions>
        );
    }
}

Networks.propTypes = {
    query: PropTypes.object,
    rowDetails: PropTypes.array,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withSearch(Networks, servicesDataKey);
